export default __webpack_public_path__ + "static/media/icone-diamante.0206a804.svg";